'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = backLink;

var _journeyHandler = require('./journeyHandler');

var _journeyHandler2 = _interopRequireDefault(_journeyHandler);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpGuiGuide = require('rp-gui-guide');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function backLink() {
    var assetsUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (_rpGuiGuide.mobileDetect.mobile()) {
        var selectors = {
            contentWrapper: '.js-contentWrapper',
            container: '.js-btnBack__container',
            link: '.js-backLink'
        };
        var classes = {
            container: 'ui-btnBack__container js-btnBack__container',
            link: 'ui-btnBack js-backLink',
            icon: 'ui-btnBack__icon',
            label: 'ui-btnBack__label'
        };
        var ANIMATION_TIME = 300;

        _journeyHandler2.default.handleSwiftypePopup();

        if (!_journeyHandler2.default.isJourneyValid() || _journeyHandler2.default.isDirectAccess()) {
            _journeyHandler2.default.resetAllJourneys();
            return;
        }
        if (_journeyHandler2.default.getLastUserJourneyEntry() === _journeyHandler2.default.getWindowLocation()) {
            _journeyHandler2.default.removeLastJourneyEntry();
        }

        var $backButton = (0, _jquery2.default)('<div class="' + classes.container + '">\n                    <a class="' + classes.link + '">\n                        <span class="' + classes.icon + '">\n                            <svg class="ui-icon">\n                                <use xlink:href="' + assetsUrl + 'img/icons.svg#icon-left" />\n                            </svg>\n                        </span>\n                        <span class="' + classes.label + '">Back</span>\n                    </a>\n                </div>');

        (0, _jquery2.default)(selectors.contentWrapper).before($backButton);
        (0, _jquery2.default)(selectors.link).attr('href', _journeyHandler2.default.getLastUserJourneyEntry()).one('click', _journeyHandler2.default.removeLastJourneyEntry.bind(_journeyHandler2.default));
        (0, _jquery2.default)(selectors.container).slideDown(ANIMATION_TIME);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-popup/lib/backLink.js
// module id = 1521
// module chunks = 0